import { Button, Center, Chip, Group, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconMailPlus } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { useState } from 'react';
import { isEmpty } from 'remeda';
import { usePopulateTemplateChannels } from '../api';
import { channelsForStepType } from './channels';

type TemplateEditorEmptyStateProps = {
  templateId: string;
  stepType: string;
};

export const TemplateEditorEmptyState = ({
  templateId,
  stepType,
}: TemplateEditorEmptyStateProps) => {
  const { t } = useTranslation();
  const { populateTemplateChannels, isPopulateTemplateChannelsLoading } =
    usePopulateTemplateChannels();
  const [selectedChannels, setSelectedChannels] = useState<string[]>([]);

  const populate = () => populateTemplateChannels({ templateId, channels: selectedChannels });

  return (
    <Center h="100%" p="xl">
      <Stack align="center" gap="lg" maw={420}>
        <ThemeIcon variant="light" size={64} radius="xl">
          <IconMailPlus size={32} stroke={1.5} />
        </ThemeIcon>
        <Stack align="center" gap={4}>
          <Text fw={600} size="lg">
            {t(i18nKeys.TEMPLATE.EMPTY_CHANNELS_TITLE)}
          </Text>
          <Text c="dimmed" size="sm" ta="center">
            {t(i18nKeys.TEMPLATE.EMPTY_CHANNELS_DESCRIPTION)}
          </Text>
        </Stack>
        <Chip.Group multiple value={selectedChannels} onChange={setSelectedChannels}>
          <Group justify="center">
            {channelsForStepType(stepType).map(({ key, labelKey, Icon }) => (
              <Chip key={key} value={key}>
                <Group component="span" gap={6} wrap="nowrap">
                  <Icon size={16} stroke={1.5} />
                  {t(labelKey)}
                </Group>
              </Chip>
            ))}
          </Group>
        </Chip.Group>
        <Button
          onClick={populate}
          disabled={isEmpty(selectedChannels)}
          loading={isPopulateTemplateChannelsLoading}
        >
          {t(i18nKeys.TEMPLATE.CREATE_CHANNELS)}
        </Button>
      </Stack>
    </Center>
  );
};
